import React, { FC, ReactNode } from 'react';
import { BarLoader } from 'react-spinners';
import { useTheme } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import loaderStyles from './loaderStyles';

const Loader: FC = () => {
    const theme = useTheme();

    return (
        <BarLoader loading color={theme?.palette?.primary?.main} role="progressbar" aria-label="Loading" />
    );
};

export default Loader;

type Props = {
    children?: ReactNode;
};

export const LoaderDialogContent: FC<Props> = ({ children }: Props) => {
    const classes = loaderStyles();
    return (
        <Grid className={classes.relativeHeight100} container justifyContent="center" alignItems="center">
            <Grid
                className={classes.absoluteHeight100}
                container
                direction="column"
                alignItems="center"
                justifyContent="center"
                role="status"
                aria-live="polite"
                aria-busy="true"
            >
                <Typography variant="h5">Loading...</Typography>
                <Loader />
            </Grid>
            {children && children}
        </Grid>
    );
};

type LoaderOnComponentProps = { text?: string | React.ReactNode; shouldShowInRelativePosition?: boolean };

// put classes.positionRelative on the parent component
export const LoaderOnComponent: FC<LoaderOnComponentProps> = ({
    text = 'Loading...',
    shouldShowInRelativePosition = false
}: LoaderOnComponentProps) => {
    const classes = loaderStyles();

    const wrapperClass = shouldShowInRelativePosition
        ? classes.wrapLoaderRelativePosition
        : classes.wrapLoader;

    return (
        <Grid className={wrapperClass} role="status" aria-live="polite" aria-busy="true">
            <Grid
                className={classes.height100}
                container
                direction="column"
                alignItems="center"
                justifyContent="center"
            >
                <Grid className={classes.loaderBox} container direction="column" alignItems="center">
                    <Typography variant="h5" gutterBottom>
                        {text}
                    </Typography>
                    <Loader />
                </Grid>
            </Grid>
        </Grid>
    );
};
